// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"200":"aee4ff66","2889":"5a544f07","3215":"58a45e7d"}[chunkId] + ".css";
};